export enum ElemntshowKind {
  /// <summary>
  /// روز
  /// </summary>
  DD = 1,
  /// <summary>
  /// روز ساعت دقیقه
  /// </summary>
  DDHHMM = 2,
  /// <summary>
  /// ساعت دقیقه
  /// </summary>
  HHMM = 3,
  /// <summary>
  /// موردی
  /// </summary>
  OtherKind = 3,
}
